import { createAction } from 'redux-actions';

export const SET_DATA_EASY_BOOKING = 'SET_DATA_EASY_BOOKING';

export const setEasyBookingThankYouData = {
  setData: createAction(SET_DATA_EASY_BOOKING),
};
